import { render, staticRenderFns } from "./workfile.vue?vue&type=template&id=3a0c87db&scoped=true"
import script from "./workfile.vue?vue&type=script&lang=js"
export * from "./workfile.vue?vue&type=script&lang=js"
import style0 from "./workfile.vue?vue&type=style&index=0&id=3a0c87db&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a0c87db",
  null
  
)

export default component.exports